import ProductVarietiesForm from '@app/components/apps/ProductVarieties/ProductVarietiesForm';
import { BaseBreadcrumb } from '@app/components/common/BaseBreadcrumb/BaseBreadcrumb';
import { Row, Col } from 'antd';
import React from 'react';

const CreateProductVarietiesPage = () => {
  return (
    <Row gutter={[16, 16]}>
      <Col span={24}>
        <BaseBreadcrumb
          routes={[
            {
              path: '/',
              breadcrumbName: 'Home',
            },
            {
              path: '/product-varieties',
              breadcrumbName: 'Create Product Variety',
            },
          ]}
        />
      </Col>
      <ProductVarietiesForm editable={true} pageTitle={'Create Product Variety'} type={'create'} />
    </Row>
  );
};

export default CreateProductVarietiesPage;
